import firebase from "firebase/compat/app";
import "firebase/compat/database";
import { environment } from "./constant";
import { json } from "./http/client";

const firebaseConfig = {
  apiKey: "AIzaSyCwdEs5CPv7NLbcLHs47cxVIrD9ElH3d6Y",
  authDomain: "sitemaster-73204.firebaseapp.com",
  databaseURL: "https://sitemaster-73204-default-rtdb.firebaseio.com",
  projectId: "sitemaster-73204",
  storageBucket: "sitemaster-73204.firebasestorage.app",
  messagingSenderId: "97124326033",
  appId: "1:97124326033:web:f7a2cbb236583123393d30",
  measurementId: "G-LJB1G81837",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const rtdb = firebase.database();

export const getToken = async (userId) => {
  const values = await rtdb
    .ref(`userTokens-${environment}/${userId}`)
    .once("value");
  return values.val() ?? {};
};

export const sendPushNotification = async (
  expoPushToken,
  title,
  body,
  screenData = null,
  _contentAvailable = false,
  uri = null
) => {
  const message = {
    to: expoPushToken,
    sound: "default",
    title: title,
    body: body,
    _contentAvailable: _contentAvailable,
    ...(uri && {
      richContent: {
        image: uri
      }
    }),
    data: screenData || {}, // Include screen navigation data
  };

  const res = await fetch("https://exp.host/--/api/v2/push/send", {
    method: "POST",
    mode: "no-cors",
    headers: {
      Accept: "application/json",
      "Accept-encoding": "gzip, deflate",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(message),
  });

  if (!res.ok) {
    console.error("Error sending push notification:", res.status);
    return false;
  }
  const data = await res.json();
  if (data.errors) {
    console.error("Error sending push notification:", data.errors);
    return false;
  }
  // console.log("Push notification sent successfully:", data);
};

export const sendFeatureRequestAccessNotification = async (
  userData,
  feature,
  site_id,
  site_data,
  org_id
) => {
  try {
    console.log("userData", userData);
    console.log("requesting feature", feature);

    let effectiveOrgId = org_id;
    if (!effectiveOrgId) {
      const org = JSON.parse(localStorage.getItem("organization") || "{}");
      effectiveOrgId = org?.id;
    }

    if (!effectiveOrgId) {
      console.error("Organization ID not found");
      return;
    }

    const userId = userData?.user;
    const now = new Date();
    const featureKey = site_id ? `${feature}-${site_id}` : `${feature}-org`;

    // 1. Check for last request (Throttling)
    const lastRequestRef = rtdb.ref(
      `access-requests-${environment}/${effectiveOrgId}/${userId}/${featureKey}/last_request`
    );
    const snapshot = await lastRequestRef.once("value");
    if (snapshot.exists()) {
      const lastRequestTime = new Date(snapshot.val());
      const diffInMs = now - lastRequestTime;
      const diffInHours = diffInMs / (1000 * 60 * 60);
      if (diffInHours < 1) {
        console.log("Request already made within the last hour");
        return { throttled: true };
      }
    }

    let members = [];
    if (site_id) {
      // Site level request
      const res = await json(`/team/list-site-members/${site_id}/`);
      if (res && res.status && res.data) {
        members = res.data.filter(
          (m) => m.joined_as === "owner" || String(m.is_admin) === "true"
        );
      }
    } else if (effectiveOrgId) {
      // Organization level request
      const res = await json(`/org/organization/${effectiveOrgId}/members/`);
      if (res && res.status && res.data) {
        members = res.data.filter(
          (m) => m.joined_as === "owner" || String(m.is_admin) === "true"
        );
      }
    }

    const title = "Feature Access Request";
    const body = `is requesting access to ${feature} ${site_data ? `in ${site_data?.name}` : ""}`;
    const pushNotificationBody = `${userData?.first_name} ${userData?.last_name} ${body}`;
    const targetIds = [];

    // 2. Send Push Notifications
    for (const member of members) {
      const targetUserId = site_id ? member.user_id : member.user?.id;
      if (!targetUserId) continue;
      targetIds.push(targetUserId);

      const userTokens = await getToken(targetUserId);
      if (userTokens && userTokens.token) {
        await sendPushNotification(userTokens.token, title, pushNotificationBody);
      }
    }

    // 3. Save Notification to RTDB
    const notificationData = {
      message: body,
      site_id: site_id || null,
      target_ids: targetIds,
      title: title,
      date: now.toISOString(),
      actor_id: userId,
      actor_name: `${userData?.first_name} ${userData?.last_name}`,
      module: feature,
      metadata: {
        site_id: site_id || null,
      },
      type: "access_request",
    };

    const notificationsRef = rtdb.ref(
      `notifications-${environment}/${effectiveOrgId}`
    );
    await notificationsRef.push(notificationData);

    // 4. Update track of last access request
    await lastRequestRef.set(now.toISOString());

    return { success: true };
  } catch (error) {
    console.error("Error sending feature request access notification:", error);
  }
};

export { firebase, rtdb };
